<template>
  <div>
    <section class="page-offset lg:bg-sand">
      <div class="container">
        <h2 class="heading">
          {{ currentPage.template.content_title }}
        </h2>
        <SofieText
          class="prose-p:text-lg max-w-2xl"
          :value="currentPage.template.about_text"
        />
        <div class="mb-2.5 flex items-end justify-between gap-3.5 sm:justify-start lg:gap-5 lg:py-4">
          <span class="text-blue text-xs font-bold lg:text-lg">{{ $t('Quickly go to') }}:</span>
          <NuxtLink
            v-for="section in Object.values(sections)"
            :key="section.id"
            class="text-xs !font-medium lg:text-lg"
            :to="`#${section.id}`"
          >
            {{ $t(section.label) }}
          </NuxtLink>
        </div>
      </div>
      <div class="lg:bg-split lg:from-sand lg:to-white">
        <div class="container">
          <Hero center-on-large>
            <SofieText
              class="hero-title green-dot-suffix"
              :value="currentPage.template.circle_title"
            />
            <SofieText
              class="max-lg:hidden lg:pt-2.5 lg:text-white"
              :value="currentPage.template.circle_text"
            />
          </Hero>
        </div>
      </div>
    </section>

    <ScrollAnchor :id="sections.members.id" />
    <section class="overflow-hidden">
      <div class="section-container">
        <div class="grid-side-content">
          <h2 class="heading">
            {{ currentPage.template.member_title }}
          </h2>
          <Readmore :text="currentPage.template.member_text" />
        </div>
      </div>
    </section>

    <ScrollAnchor :id="sections.vacancies.id" />
    <section class="section-container lg:grid-side-content">
      <div class="lg:w-3/4">
        <h2 class="heading pb-5 lg:pb-5">
          {{ currentPage.template.vacancies_title }}
        </h2>
        <SofieText
          class="prose max-lg:hidden lg:pb-10"
          :value="currentPage.template.vacancies_text"
        />
        <div class="block sm:hidden">
          <VacanciesCarousel
            :vacancies="vacancies"
          />
        </div>
        <VacanciesList
          class="hidden sm:block lg:hidden"
          :vacancies="vacancies.slice(0,5)"
        />
        <div class="heading-sub pt-5 lg:hidden">
          {{ $t('Apply or know more?') }}
        </div>
        <VacanciesRecruiterCard
          :contact="recruiter"
        />
      </div>
      <VacanciesList
        class="hidden lg:block"
        :vacancies="vacancies.slice(0,5)"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import {useVacanciesQuery} from '~/graphql/graphql';

const {t} = useI18n();

definePageMeta({
  auth: false,
  middleware: ['sofie-page'],
});

const sections = {
  members: {label: 'Members', description: 'Members description', id: t('Members').toLowerCase()},
  vacancies: {label: 'Vacancies', description: 'Do you want to apply or know more about our vacancies?', id: t('Vacancies').toLowerCase()},
} as const;

const currentPage = useSofiePage();

const {result: queryResult} = useVacanciesQuery();
const vacancies = computed(() => queryResult.value?.vacancies ?? []);

const recruiter = computed(() => vacancies.value[0]?.recruiter);
</script>
